import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import Contact from "../../image/contact.jpg";
import cl from "./Contacts.module.css";

const Contacts = (props) => {
  const position = props.coordinates?.split(", ") || [40.808712, -73.946818];

  return (
    <section className={cl.contact}>
      <div className={cl.profile}>
        <div className={cl.info}>
          <h1>Find a Store Near You</h1>
        </div>
      </div>
      <div className={cl.main}>
        <div
          style={{
            backgroundColor: "var(--secondary)",
            borderRadius: " 5px",
            padding: "20px",
            marginBottom: "10px",
            textAlign: "center",
          }}
        >
          <p>
            If you have any questions or concerns, please do not hesitate to
            contact us.
          </p>
          <p>We would love to hear from you, contact us on:</p>
          <p>
            Email:{" "}
            <a
              style={{ color: "var(--tertiary)" }}
              href={"mailto: support@" + props.domain}
            >
              support@{props.domain}
            </a>
          </p>
          <p>{props.shopName} Shop Group</p>
          <p>{props.address}</p>
          <p>
            Tel:{" "}
            <a style={{ color: "var(--tertiary)" }} href="tel:+18464947855">
              1-846-494-7855 x844
            </a>
          </p>
        </div>

        <div className={cl.contacts}>
          <MapContainer
            center={position}
            zoom={12}
            scrollWheelZoom={false}
            style={{ height: "250px", width: "50%", margin: "1rem auto" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
